import styled from 'styled-components';
import { FlexDiv, GenericSpan } from '../Styles';
import { ASSET_PATH } from 'assetsPath';

export const ErrorContainer = styled(FlexDiv)`
    background-color: ${(props) => props.$bg || 'inherit'}
`;

export const ErrorMsg = styled.div`
    margin-left:${(props) => (props.msg_L || '0')};
    margin-top:${(props) => (props.msg_T || '0')};
    text-align:${(props) => props.txtAlign || 'inherit'}
`;

export const ErrorIcon = styled(GenericSpan)`
    width: ${(props) => (props.imgWidth || '80px')};
    height: ${(props) => (props.imgHeight || '80px')};
    margin: ${(props) => (props.imgMargin || '10px')};
    background: url(${ASSET_PATH.IMAGES}server-error.png) no-repeat; 
    background-size: cover;
    display: inline-block;
`;

export const ErrorHeading = styled.h3`
    font-size: ${(props) => (props.fsize || '14px')};
    font-weight: 900;
    margin-bottom: 8px;
`;
